export default class SelectProvider {
  public emailProvider: string;

  constructor(options) {
    this.emailProvider = options.emailProvider;
  }

  complete() {
    return this.emailProvider;
  }
}
